import React from 'react';

import DataContainer from 'Components/UI/DataContainer';
import { useIncludedRelationshipContext } from 'Views/Page/Contexts/IncludedRelationshipContext';
import Content from './Content';

const Container = () => {
  const { relationshipCollection, isInitializing } = useIncludedRelationshipContext();

  return (
    <DataContainer
      loading={isInitializing}
      component={Content}
      componentProps={{
        relationshipCollection,
      }}
    />
  );
};

export default Container;
